var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTennisIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2129_215)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 93.8485,
    cy: 89.8485,
    r: 87.3485,
    fill: "#AEFF00",
    stroke: "#0C0F14",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.719 87.3249C168.477 126.636 136.177 159.246 95.4391 160.031C54.7008 160.816 21.1691 129.474 20.4117 90.1632C19.6542 50.852 51.9537 18.2422 92.6921 17.4573C133.43 16.6723 166.962 48.0138 167.719 87.3249Z",
    fill: "white",
    stroke: "#0C0F14",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.536 46.5897C113.054 23.1368 75.0925 23.1368 51.611 46.5897C28.1297 70.0423 28.1297 107.958 51.611 131.41C63.352 143.137 78.6149 149 94.0734 149C109.532 149 124.795 143.137 136.536 131.41C159.821 107.958 159.821 70.0423 136.536 46.5897ZM150.233 83.7232C144.559 84.7004 138.884 88.2182 134.579 93.6905C130.861 98.5765 128.317 104.049 125.969 109.521C125.578 110.498 125.186 111.476 124.795 112.257C122.056 118.316 118.924 124.57 113.837 128.674C105.423 135.71 94.0734 135.515 88.0074 134.733C72.3531 132.779 58.2641 123.397 52.198 110.498C45.5452 96.622 48.8716 79.0324 59.8296 69.8468C69.0264 62.0294 81.9413 60.6612 94.4648 59.2931C97.5955 58.9022 101.118 58.5113 104.249 58.1204C108.945 57.3386 113.837 56.3616 117.946 53.6253C121.86 51.0848 124.599 46.1985 124.991 41.7035C128.122 43.8534 131.252 46.1985 133.992 49.1303C143.58 58.9022 149.059 71.215 150.233 83.7232ZM133.992 128.87C112.076 150.759 76.2666 150.759 54.3506 128.87C32.4346 106.98 32.4346 71.215 54.3506 49.3257C65.3086 38.3811 79.789 32.9088 94.2691 32.9088C103.662 32.9088 113.054 35.2539 121.468 39.9447C121.468 40.1402 121.468 40.1402 121.468 40.3356C121.86 44.0489 119.512 48.7394 115.989 51.0848C112.467 53.4299 107.966 54.4071 103.662 54.9935C100.531 55.3844 97.2042 55.7753 94.0734 56.1662C81.1585 57.5343 67.6569 59.0976 57.4816 67.5017C45.1538 77.6645 41.4357 97.0129 48.8716 112.453C55.7204 126.524 70.3962 136.687 87.616 138.837C89.3772 139.033 91.3338 139.228 93.6821 139.228C100.335 139.228 109.141 137.86 116.381 131.801C122.056 127.111 125.382 120.466 128.317 114.016C128.708 113.039 129.1 112.062 129.491 111.28C131.839 106.003 134.187 100.726 137.71 96.2314C141.428 91.5406 145.928 88.6091 150.624 87.8273C150.82 102.485 145.341 117.534 133.992 128.87Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2129_215",
    x: 0,
    y: 0,
    width: 187.697,
    height: 187.697,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2129_215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2129_215",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennisIcon);
export default __webpack_public_path__ + "static/media/TennisIcon.cfbabf979244dda3a7eccf63827150f1.svg";
export { ForwardRef as ReactComponent };